import { io } from "socket.io-client";
import { env } from "../env";

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.listeners = {};
    this.businessGroupChannel = null;
    this.posChannel = null;
    this.kitchenChannel = null;
    this.orderChannel = null;
    this.kitchenManagementChannel = null;
    this.notification = null;
  }

  connect(url = env.REACT_APP_SOCKET_URL) {
    if (this.socket) {
      // [fix] force reconnect if socket gave up (reconnectionAttempts exhausted)
      if (!this.socket.connected && !this.socket.active) this.socket.connect()
      return this.socket;
    }

    this.socket = io(url, {
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      timeout: 20000,
    });

    this.socket.on("connect", () => {
      console.log("Socket server :", env.REACT_APP_SOCKET_URL);
      console.log("Socket เชื่อมต่อแล้ว:", this.socket.id);
      this.isConnected = true;

      if (this.businessGroupChannel) {
        this.socket.emit("subscribe", this.businessGroupChannel);
        console.log(`สมัครสมาชิกช่อง ${this.businessGroupChannel} แล้ว`);
      }

      if (this.posChannel) {
        this.socket.emit("subscribe", this.posChannel);
        console.log(`สมัครสมาชิกช่อง ${this.posChannel} แล้ว`);
      }
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Socket ถูกตัดการเชื่อมต่อ:", reason);
      this.isConnected = false;
    });

    this.socket.on("connect_error", (error) => {
      console.error("เกิดข้อผิดพลาดในการเชื่อมต่อ Socket:", error);
      this.isConnected = false;
    });
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
      this.businessGroupChannel = null;
      this.posChannel = null;
      this.orderChannel = null;
      this.kitchenChannel = null;
    }
  }
  disconnectOrder() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
      this.orderChannel = null;
    }
  }
  disconnectKitchen() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
      this.businessGroupChannel = null;
      this.kitchenChannel = null;
    }
  }

  setBusinessGroup(email) {
    if (!email) {
      console.error("ไม่ได้ระบุอีเมล");
      return;
    }

    this.businessGroupChannel = `user_business_group:${email}`;
    console.log(`กำหนดกลุ่มธุรกิจ: ${this.businessGroupChannel}`);

    if (this.socket && this.isConnected) {
      this.socket.emit("subscribe", this.businessGroupChannel);
      console.log(`สมัครสมาชิกช่อง ${this.businessGroupChannel} แล้ว`);
    }
  }

  setPosChannel(id) {
    if (!id) {
      console.error("ไม่ได้ระบุ ID ของ POS");
      return;
    }

    this.posChannel = `pos:${id}`;
    console.log(`กำหนดช่อง POS: ${this.posChannel}`);

    if (this.socket && this.isConnected) {
      this.socket.emit("subscribe", this.posChannel);
      console.log(`สมัครสมาชิกช่อง ${this.posChannel} แล้ว`);
    }
  }

  setOrderChannel(id) {
    if (!id) {
      console.error("ไม่ได้ระบุ ID ของ Order");
      return;
    }

    this.orderChannel = `order:${id}`;
    console.log(`กำหนดช่อง Order: ${this.orderChannel}`);

    if (this.socket && this.isConnected) {
      this.socket.emit("subscribe", this.orderChannel);
      console.log(`สมัครสมาชิกช่อง ${this.orderChannel} แล้ว`);
    }
    this.socket?.on("connect", () => {
      this.socket.emit("subscribe", this.orderChannel);
      console.log(`[Reconnect] สมัครสมาชิกช่อง ${this.orderChannel} ซ้ำอีกครั้ง`);
    });
  }
  registerOrderHandler(callback) {
    if (!this.socket) {
      console.error("Socket ยังไม่ได้เชื่อมต่อ");
      return () => {};
    }

    if (!this.orderChannel) {
      console.error("ยังไม่ได้กำหนดช่อง Order");
      return () => {};
    }

    const handler = (msg) => {
      console.log(`order ได้รับข้อความจาก ${this.orderChannel}:`, msg);
      if (msg === "logout") {
        console.log("ได้รับคำสั่งออกจากระบบ Order กำลังออกจากระบบ...");
      }
      callback(msg);
    };

    this.socket.on(this.orderChannel, handler);
    console.log(`กำลังฟังข้อความจากช่อง Order : ${this.orderChannel}`);

    return () => {
      if (this.socket) {
        this.socket.off(this.orderChannel, handler);
      }
    };
  }
  setKitchenChannel(id) {
    this.kitchenChannel = `branch_kitchen:${id}`;
    console.log(`กำหนดช่อง Kitchen: ${this.kitchenChannel}`);

    if (this.socket && this.socket.connected) {
      this.socket.emit("subscribe", this.kitchenChannel);
      console.log(`สมัครสมาชิกช่อง ${this.kitchenChannel} แล้ว`);
    }

    this.socket?.on("connect", () => {
      this.socket.emit("subscribe", this.kitchenChannel);
      console.log(`[Reconnect] สมัครสมาชิกช่อง ${this.kitchenChannel} ซ้ำอีกครั้ง`);
    });
  }
  setKitchenManageMentChannel(id) {
    this.kitchenManagementChannel = `kitchen:${id}`;
    console.log(`กำหนดช่อง Kitchen: ${this.kitchenManagementChannel}`);

    if (this.socket && this.socket.connected) {
      this.socket.emit("subscribe", this.kitchenManagementChannel);
      console.log(`สมัครสมาชิกช่อง ${this.kitchenManagementChannel} แล้ว`);
    }
  }
  setNotificationChannel(id) {
    this.notification = `pos_notification:${id}`;
    console.log(`กำหนดช่อง Kitchen: ${this.notification}`);

    if (this.socket && this.socket.connected) {
      this.socket.emit("subscribe", this.notification);
      console.log(`สมัครสมาชิกช่อง ${this.notification} แล้ว`);
    }
    this.socket?.on("connect", () => {
      this.socket.emit("subscribe", this.notification);
      console.log(`[Reconnect] สมัครสมาชิกช่อง ${this.notification} ซ้ำอีกครั้ง`);
    });
  }
  registerNotificationHandler(callback) {
    if (!this.socket) {
      console.error("Socket ยังไม่ได้เชื่อมต่อ");
      return () => {};
    }

    if (!this.notification) {
      console.error("ยังไม่ได้กำหนดช่อง Notification");
      return () => {};
    }
    const handler = (msg) => {
      console.log(`ได้รับข้อความจาก ${this.notification}:`, msg);
      if (msg === "logout") {
        console.log("ได้รับคำสั่งออกจากระบบ Notification กำลังออกจากระบบ...");
      }
      callback(msg);
    };
    this.socket.on(this.notification, handler);
    console.log(`กำลังฟังข้อความจากช่อง Notification : ${this.notification}`);

    return () => {
      if (this.socket) {
        this.socket.off(this.notification, handler);
      }
    };
  }
  registerKitchenHandler(callback) {
    if (!this.socket) {
      console.error("Socket ยังไม่ได้เชื่อมต่อ");
      return () => {};
    }

    if (!this.kitchenChannel) {
      console.error("ยังไม่ได้กำหนดช่อง Kitchen");
      return () => {};
    }
    const handler = (msg) => {
      console.log(`ได้รับข้อความจาก ${this.kitchenChannel}:`, msg);
      if (msg === "logout") {
        console.log("ได้รับคำสั่งออกจากระบบ Kitchen กำลังออกจากระบบ...");
      }
      callback(msg);
    };
    this.socket.on(this.kitchenChannel, handler);
    console.log(`กำลังฟังข้อความจากช่อง Kitchen : ${this.kitchenChannel}`);

    return () => {
      if (this.socket) {
        this.socket.off(this.kitchenChannel, handler);
      }
    };
  }
  registerkitchenManagementChannelHandler(callback) {
    if (!this.socket) {
      console.error("Socket ยังไม่ได้เชื่อมต่อ");
      return () => {};
    }

    if (!this.kitchenManagementChannel) {
      console.error("ยังไม่ได้กำหนดช่อง Kitchen");
      return () => {};
    }
    const handler = (msg) => {
      console.log(`ได้รับข้อความจาก ${this.kitchenManagementChannel}:`, msg);
      callback(msg);
    };
    this.socket.on(this.kitchenManagementChannel, handler);
    console.log(`กำลังฟังข้อความจากช่อง Kitchen : ${this.kitchenManagementChannel}`);

    return () => {
      if (this.socket) {
        this.socket.off(this.kitchenManagementChannel, handler);
      }
    };
  }
  registerLogoutHandler(callback) {
    if (!this.socket) {
      console.error("Socket ยังไม่ได้เชื่อมต่อ");
      return () => {};
    }

    if (!this.businessGroupChannel) {
      console.error("ยังไม่ได้กำหนดกลุ่มธุรกิจ");
      return () => {};
    }

    const handler = (msg) => {
      console.log(`ได้รับข้อความจาก ${this.businessGroupChannel}:`, msg);
      if (msg === "logout") {
        console.log("ได้รับคำสั่งออกจากระบบ กำลังออกจากระบบ...");
        callback();
      }
    };

    this.socket.on(this.businessGroupChannel, handler);
    console.log(`กำลังฟังข้อความจากช่อง USER : ${this.businessGroupChannel}`);

    return () => {
      if (this.socket) {
        this.socket.off(this.businessGroupChannel, handler);
      }
    };
  }

  /**
   * POS channel logout: plain "logout" = everyone on this terminal; JSON with targetUserBusinessGroupId = only that user (takeover).
   */
  shouldLogoutFromPosSocketMessage(msg, currentUserBusinessGroupId) {
    if (msg === "logout") return true;
    let parsed = msg;
    if (typeof msg === "string") {
      try {
        parsed = JSON.parse(msg);
      } catch {
        return false;
      }
    }
    if (!parsed || typeof parsed !== "object") return false;
    if (parsed.logout !== true) return false;
    const target = parsed.targetUserBusinessGroupId;
    if (target == null) return true;
    if (currentUserBusinessGroupId == null || currentUserBusinessGroupId === "") {
      return false;
    }
    return String(target) === String(currentUserBusinessGroupId);
  }

  registerPosLogoutHandler(callback, getCurrentUserBusinessGroupId) {
    if (!this.socket) {
      console.error("Socket ยังไม่ได้เชื่อมต่อ");
      return () => {};
    }

    if (!this.posChannel) {
      console.error("ยังไม่ได้กำหนดช่อง POS");
      return () => {};
    }

    const handler = (msg) => {
      console.log(`ได้รับข้อความจาก ${this.posChannel}:`, msg);
      const uid =
        typeof getCurrentUserBusinessGroupId === "function"
          ? getCurrentUserBusinessGroupId()
          : null;
      if (this.shouldLogoutFromPosSocketMessage(msg, uid)) {
        console.log("ได้รับคำสั่งออกจากระบบ POS กำลังออกจากระบบ...");
        callback();
      }
    };

    this.socket.on(this.posChannel, handler);
    console.log(`กำลังฟังข้อความจากช่อง POS : ${this.posChannel}`);

    return () => {
      if (this.socket) {
        this.socket.off(this.posChannel, handler);
      }
    };
  }
}

const socketService = new SocketService();
export default socketService;
